
import {View} from 'backbone';
import template from 'dashboard/connections/details/connection-directory-services.ejs';
import ConnectionResearchView from 'dashboard/connections/details/ConnectionResearchView';
import NotificationService from 'NotificationService.js';

class ConnectionDirectoryServices extends View {
    initialize(opts){

        this.template = template;
        this.connectionService = opts.connectionService;

        this.events = {
            'change input[name=_url],input[name=_username],input[name=_password],input[name=_timeout]': 'processConnectionInputs',
            'change select[name=_datasourceName],select[name=_baseDnName]':'changeDatabase',
            'change input[name=_useProxy]': 'processConnectionCheckboxes',
            'click input[name=checkConnection]': 'checkConnection'
        };

        this.model.set('databaseConnections', [], { silent: true });      
        
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    processConnectionCheckboxes(){
        return this.connectionService.processConnectionCheckboxes.apply(this.connectionService, arguments);
    }

    processConnectionInputs(){
        return this.connectionService.processConnectionInputs.apply(this.connectionService, arguments);
    }

    changeDatabase(event) {
        let currentModel = this.model.get('currentConnectionDetails');
        currentModel.ConnectionXML.Connection[event.target.name] = event.target.options[event.target.selectedIndex].innerText;
        currentModel.ConnectionXML.Connection[event.target.name.replace('Name','Id')] = event.target.value;

        if (event.target.name === '_datasourceName'){
            const datasourcesArray = this.model.get('databaseConnections');
            const selectedDataSource =_.find(datasourcesArray, (ds) => { return ds._id.toString() === event.target.value });
            let _baseDnId, _baseDnName;
            if (selectedDataSource.database){
                const dataBaseArray = $.isArray(selectedDataSource.database) ? selectedDataSource.database : [selectedDataSource.database];
                _baseDnId = dataBaseArray[0]._id;
                _baseDnName = dataBaseArray[0]._name;
            }

            currentModel.ConnectionXML.Connection['_baseDnId'] = _baseDnId;
            currentModel.ConnectionXML.Connection['_baseDnName'] = _baseDnName;
        }

        this.model.set('currentConnectionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true);
        this.render();
    }

    checkConnection() {
            this.connectionService.checkConnection()
            .then(result => {
                this.model.set('databaseConnections', result.response.datasource ? $.isArray(result.response.datasource) ? result.response.datasource : [result.response.datasource] : [], { silent: true });
                const currentModel = this.model.get('currentConnectionDetails');

                if (result.response.datasource) {                    
                    const datasourcesArray = $.isArray(result.response.datasource) ? result.response.datasource : [result.response.datasource];

                    let dataSourceId = currentModel.ConnectionXML.Connection._datasourceId ? currentModel.ConnectionXML.Connection._datasourceId : datasourcesArray[0]._id;
                    const selectedDataSource = _.find(datasourcesArray, (ds) => { return ds._id.toString() === dataSourceId.toString() });
                    if (selectedDataSource) {
                        let dataSourceName = selectedDataSource._name;

                        currentModel.ConnectionXML.Connection['_datasourceId'] = dataSourceId;
                        currentModel.ConnectionXML.Connection['_datasourceName'] = dataSourceName;

                        if (selectedDataSource.database) {
                            const dataBaseArray = $.isArray(selectedDataSource.database) ? selectedDataSource.database : [selectedDataSource.database];
                            let dataBaseId = currentModel.ConnectionXML.Connection._baseDnId ? currentModel.ConnectionXML.Connection._baseDnId : dataBaseArray[0]._id;
                            const selectedDatabase = _.find(dataBaseArray, (db) => { return db._id.toString() === dataBaseId.toString() });
                            let dataBaseName = '';

                            if (selectedDatabase) {
                                dataBaseName = selectedDatabase._name;
                            } else {
                                dataBaseId = dataBaseArray[0]._id;
                                dataBaseName = dataBaseArray[0]._name;
                            }

                            currentModel.ConnectionXML.Connection['_baseDnId'] = dataBaseId;
                            currentModel.ConnectionXML.Connection['_baseDnName'] = dataBaseName;
                        }
                    }
                } else {
                    currentModel.ConnectionXML.Connection['_datasourceId'] = '';
                    currentModel.ConnectionXML.Connection['_datasourceName'] = '';
                    currentModel.ConnectionXML.Connection['_baseDnId'] = '';
                    currentModel.ConnectionXML.Connection['_baseDnName'] = '';
                    NotificationService.error('No data sources found');
                }

                this.model.set('currentConnectionDetails', currentModel, { silent: true });
                this.model.set('hasChanges', true);
                this.render();
            })
            .catch(err => {
                console.log(err);
            });
    }

    render(){
        this.$el.empty();
        let connection = this.model.get('currentConnectionDetails');
        //Check if Datasource and Distinguised name are already defined
        let databaseConnections = this.model.get('databaseConnections');
        let disableDataSourceSelects = false;
        if (!databaseConnections || databaseConnections.length === 0) {
            const dataSourceId = this.model.get('dataSourceId');
            if (connection.ConnectionXML.Connection['_datasourceId'] && connection.ConnectionXML.Connection['_datasourceId'] !== '') {
                let _databaseConnection = { _id: connection.ConnectionXML.Connection['_datasourceId'], _name: connection.ConnectionXML.Connection['_datasourceName'] };
                if (connection.ConnectionXML.Connection['_baseDnId'] && connection.ConnectionXML.Connection['_baseDnId'] !== '') {
                    _databaseConnection.database = [{ _id: connection.ConnectionXML.Connection['_baseDnId'], _name: connection.ConnectionXML.Connection['_baseDnName'] }];
                }

                if (!databaseConnections) {
                    databaseConnections = [];
                }

                databaseConnections.push(_databaseConnection);
                this.model.set('databaseConnections', databaseConnections, { silent: true });
                disableDataSourceSelects = true;
            }
        }

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const connectionResearchView = new ConnectionResearchView({el:'#connectionResearch', model:this.model });
        connectionResearchView.render();        

        $('[name=_datasourceName]')
            .find("option[value='" + connection.ConnectionXML.Connection['_datasourceId'] + "']")
            .attr('selected', true);
        
        $('[name=_baseDnName]')
            .find("option[value='" + connection.ConnectionXML.Connection['_baseDnId'] + "']")
            .attr('selected', true);

        if (disableDataSourceSelects){
            $('[name=_datasourceName]').attr('disabled', 'true');
            $('[name=_baseDnName]').attr('disabled', 'true');
        }


        this.delegateEvents();
        return this;
    }

}

export default ConnectionDirectoryServices;